import styled, { css } from 'styled-components';

export const verticalContainerStyles = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const horizontalContainerStyles = css`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
`;

export const OffersContainer = styled.div`
  ${verticalContainerStyles};
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
`;

export const DatesContainer = styled.div`
  ${verticalContainerStyles};
  width: 100%;
`;

export const FeaturesContainer = styled.div`
  ${verticalContainerStyles};
  width: 100%;
`;

export const FacilitiesContainer = styled.div`
  ${horizontalContainerStyles};
  margin-bottom: 8px;

  ${DatesContainer} + & {
    margin-top: 8px;
  }

  &:last-child {
    margin-bottom: 0;
  }

  > div {
    width: auto;

    > div {
      @container cards-grid (max-width: 787px) {
        .icon-right {
          margin-left: 0;
        }
        &:first-child {
          //  hide left icon
          display: none;
        }
      }
    }
  }
`;

export const TransportFeaturesContainer = styled.div<{ $doublePricing?: boolean }>`
  ${verticalContainerStyles};
  margin-top: 12px;
  width: 100%;

  ${({ $doublePricing, theme }) =>
    $doublePricing
      ? css`
          padding-top: 8px;
          border-top: 1px solid ${theme.kallisto.color.border.static.borderDisabled};
        `
      : css`
          background-color: ${theme.kallisto.color.background.static.backgroundLayer01};
          padding: 8px;
          border-radius: 8px;
        `}

  @media (min-width: 768px) {
    margin-top: 8px;
  }

  &:has(.loader) {
    margin-top: 16px;
    background: unset;
    padding: ${({ $doublePricing }) => ($doublePricing ? '16px 0 0 0' : '0')};
  }

  > div {
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
